const config = {
  purge: [],
  darkMode: false, // or 'media' or 'class'
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      screens: {
        'lt-short': { raw: '(max-height: 549px)' },
        short: { raw: '(min-height: 550px)' },
        'lt-tall': { raw: '(max-height: 767px)' },
        tall: { raw: '(min-height: 768px)' },
        'lt-micro': { raw: '(max-width: 320px)' },
        'lt-tiny': { raw: '(max-width: 450px)' },
        'lt-sm': { raw: '(max-width: 639px)' },
        'lt-md': { raw: '(max-width: 767px)' },
        'lt-lg': { raw: '(max-width: 1023px)' },
        'not-touch': { raw: '(hover: hover) and (pointer: fine)' },
        'has-touch': { raw: '(hover: none), (pointer: coarse)' },
        'touch-landscape': { raw: '(hover: none) and (pointer: coarse) and (orientation: landscape)' },
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [],
};

export default config;
